const dataPosts = [
    {
      imageSrc:
        "https://images.unsplash.com/photo-1669399213378-2853e748f217?q=80&w=500&auto=format&fit=crop",
      category: "Government of India",
      title: "Publicly available datasets of Ministry of Statistics and Programme Implementation",
      url: "https://esankhyiki.mospi.gov.in/catalogue-main"
    },
    {
      imageSrc:
        "https://static.businessworld.in/OIP%20(9)_20250217130222_original_image_4.webp",
      category: "IndiaAI Initiative",
      title: "IndiaAI Datasets",
      url: "https://indiaai.gov.in/datasets"
    },
    {
      imageSrc:
          "https://images.unsplash.com/photo-1601897690942-bcacbad33e55?q=80&w=500&auto=format&fit=crop",
        // "https://images.unsplash.com/photo-1499364615650-ec38552f4f34?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80",

      category: "Government of India",
      title: "Trade Statistics of India",
      url: "https://www.commerce.gov.in/trade-statistics/"
    },
    //     {
    //   imageSrc:
    //     "https://images.unsplash.com/photo-1499364615650-ec38552f4f34?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80",
    //   category: "Discover",
    //   title: "This female band is making buzz all over the world",
    //   url: "https://timerse.com"
    // },

  ];

  export { dataPosts };